import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import Logo from '../components/Logo';

const LegalNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="pt-20 pb-12 md:pb-16 lg:pb-20 min-h-screen bg-luxury-cream relative">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="section-padding relative z-10"
        >
          {/* Logo */}
          <div className="flex justify-center mb-8">
            <Logo 
              width={80} 
              height={80} 
              className="w-20 h-20 md:w-24 md:h-24"
            />
          </div>
          
          <h1 className="text-5xl font-display text-luxury-black mb-12 text-center">
            {t('legal.title')}
          </h1>

          <div className="max-w-4xl mx-auto space-y-8 text-luxury-black/80">
            <section>
              <p className="mb-6">{t('legal.intro')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('legal.editor.title')}</h2>
              <p className="mb-2">{t('legal.editor.description')}</p>
              <div className="space-y-2 pl-4">
                <p>{t('legal.editor.phone')}</p>
                <p>{t('legal.editor.webmaster')}</p>
                <p>{t('legal.editor.host')}</p>
              </div>
              <p className="mt-4">{t('legal.editor.contact')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('legal.dataProcessing.title')}</h2>
              <p className="mb-4">{t('legal.dataProcessing.description1')}</p>
              <p className="mb-4">{t('legal.dataProcessing.description2')}</p>
              <p>{t('legal.dataProcessing.description3')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('legal.cookies.title')}</h2>
              <p className="mb-4">{t('legal.cookies.description1')}</p>
              <p className="mb-4">{t('legal.cookies.description2')}</p>
              <p className="mb-4">{t('legal.cookies.description3')}</p>
              <p>{t('legal.cookies.description4')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('legal.dataRetention.title')}</h2>
              <p>{t('legal.dataRetention.description')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('legal.telemarketing.title')}</h2>
              <p className="mb-4">{t('legal.telemarketing.description1')}</p>
              <p>{t('legal.telemarketing.description2')}</p>
            </section>

            <section>
              <h2 className="text-2xl font-display mb-4">{t('legal.rights.title')}</h2>
              <p className="mb-4">{t('legal.rights.description')}</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>{t('legal.rights.info')}</li>
                <li>{t('legal.rights.correction')}</li>
                <li>{t('legal.rights.deletion')}</li>
                <li>{t('legal.rights.limitation')}</li>
                <li>{t('legal.rights.portability')}</li>
                <li>{t('legal.rights.revocation')}</li>
                <li>{t('legal.rights.opposition')}</li>
              </ul>
              <p className="mt-4">{t('legal.rights.contact')}</p>
            </section>
          </div>
        </motion.div>
      </div>
  );
};

export default LegalNotice;